import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import Button from 'components/Button/Button';
import FormRadio from 'components/FormRadio/FormRadio';
import Modal from 'components/Modal/Modal';
import PayByPoints from 'components/PayByPoints/PayByPoints';
import ToggleSearchBar from 'components/ToggleSearchBar/ToggleSearchBar';
import { actions as productActions } from 'coupon-common/src/modules/products';
import { dispatchAsAsync } from 'coupon-common/src/utils';

const PaymentModal = ({
    isOpen,
    onClose,
    onConfirm,
    message,
    productCode,
    products,
    dispatch
}) => {
    useEffect(() => {
        if (isOpen) {
            dispatchAsAsync(
                productActions.getProducts(),
                dispatch
            );
        }
    }, [isOpen, dispatch]);

    const productToPurchase = products.find(
        (prod) => prod.product_code === productCode
    );

    if (!isOpen) return null;

    return (
        <Modal
            // title="Purchase Push Notifications"
            isOpen={isOpen}
            onRequestClose={onClose}
            title={message}
        >
            {/* <div className="mb-3 text-muted">
                {message}
            </div> */}

            {/* Future payment method toggle */}
            {/*
            <ToggleSearchBar
                options={[
                    { label: "Points", value: "points" },
                    { label: "Card", value: "card" }
                ]}
                activeValue={isActive}
                onChange={handleChange}
            />
            */}

            <PayByPoints
                onConfirm={onConfirm}
                onClose={onClose}
                product={productToPurchase}
            />
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    products: state.products.products || []
});

export default connect(mapStateToProps)(PaymentModal);